module.exports = __webpack_public_path__ + "pr.svg?688c6f9025626aa01ad7b8a3b0322401";